import styled from 'styled-components'

import {
  Collapse as C,
} from 'antd'

const { Panel: P } = C

const Panel = styled(P)`
  -webkit-box-shadow: 0 1px 4px rgba(41,48,59,.2);
  -webkit-transition: box-shadow .4s ease-in-out;
  -moz-transition: box-shadow .4s ease-in-out;
  -ms-transition: box-shadow .4s ease-in-out;
  -o-transition: box-shadow .4s ease-in-out;
  transition: box-shadow .4s ease-in-out;
  box-shadow: 0 1px 4px rgba(41,48,59,.2);
  background: #fff;
  border: 0;
  border-radius: 0;
  margin-bottom: 24px;
  overflow: hidden;

  .ant-collapse-header {
    color: red;
    padding: 16px 0 16px 32px !important;
  }

  .ant-collapse-content {
    padding: 0;
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lecture {
    padding: 8px 36px;
    font-size: 16px;
    font-weight: 400;
  }

  .lecture:hover {
    cursor: pointer;
    background: #f2f3f5;
  }

  .section {
    color: #9BA0A7;
  }

  .playing {
    background: #27AE60;
    color: #fff;
  }

  .playing:hover {
    background: #209A54;
  }

  .title {
    position: absolute;
    right: 16px;
    top: 16px;
  }

  .arrow {
    display: none !important;
  }

  .succeeded {
    color: #27AE60;
  }

  &:hover {
    -webkit-box-shadow: 0 0 5px rgba(41,48,59,.5);
    box-shadow: 0 0 5px rgba(41,48,59,.5)

  }
`

export const _Collapse = {
  Panel,
}



// WEBPACK FOOTER //
// ./src/styled/collapse.js